<template>
  <v-app>
    <v-app-bar
      app
      color="#291f99"
      dark
    >
      <div class="d-flex align-center">
        <a href="https://precursorsecurity.com/">
        <v-img
          alt="Precursor Security Logo"
          class="shrink mr-2"
          contain
          src="@/assets/precursor-logo-849x250px.png"
          transition="scale-transition"
          width="200"
        />
      </a>
      </div>

      <v-spacer></v-spacer>

      <v-btn
        href="https://precursorsecurity.com/"
        target="_blank"
        text
      >
        <span class="mr-2">Precursor Security Website</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
            <v-switch v-model="$vuetify.theme.dark" hide-details inset label="Theme Dark"></v-switch>
    </v-app-bar>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
    methods: {
  },
};
</script>
